import React, { useEffect, useState } from "react";
import { Form, Button, Spinner } from "react-bootstrap";
import axios from "axios";
import ConfigFrService from "../../services/configFr.service";
import "./index.scss"
import ConfigUkService from "../../services/configUkservice";
const configUkService = new ConfigUkService();
const ConfigUkTab = ({ configId }) => {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [formData, setFormData] = useState({
    fraisDeGestion: "",
    tauxChargesPatronales: "",
    tauxChargesSalariales: "",
  });

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const res = await configUkService?.getConfiguration(configId);
        setFormData(res.data);
      } catch (err) {
        console.error("Erreur lors du chargement de la configuration", err);
      } finally {
        setLoading(false);
      }
    };

    fetchConfig();
  }, [configId]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: parseFloat(e.target.value),
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await  await configUkService?.updateConfiguration(configId, formData); 
      alert("Configuration mise à jour avec succès !");
    } catch (err) {
      console.error("Erreur lors de la mise à jour", err);
      alert("Une erreur est survenue !");
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <Spinner animation="border" />;

  return (
    <Form onSubmit={handleSubmit}>
      <Form.Group controlId="fraisDeGestion" className="mb-3">
        <Form.Label>Frais de gestion (%)</Form.Label>
        <Form.Control
          type="number"
          name="fraisDeGestion"
          value={formData.fraisDeGestion}
          onChange={handleChange}
          required
          step="0.01"
        />
      </Form.Group>

      <Form.Group controlId="tauxChargesPatronales" className="mb-3">
        <Form.Label>Taux charges patronales (%)</Form.Label>
        <Form.Control
          type="number"
          name="tauxChargesPatronales"
          value={formData.tauxChargesPatronales}
          onChange={handleChange}
          required
          step="0.01"
        />
      </Form.Group>

      <Form.Group controlId="tauxChargesSalariales" className="mb-3">
        <Form.Label>Taux charges salariales (%)</Form.Label>
        <Form.Control
          type="number"
          name="tauxChargesSalariales"
          value={formData.tauxChargesSalariales}
          onChange={handleChange}
          required
          step="0.01"
        />
      </Form.Group>

      <Button type="submit" disabled={saving} className="btn-modif">
        {saving ? "Sauvegarde..." : "Mettre à jour"}
      </Button>
    </Form>
  );
};

export default ConfigUkTab;
